'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _type = require('../type');

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var format = function format(input, previous) {
  if (!input) return '';
  var value = ('' + input).replace(/[^0-9.]/g, '');

  var _value$split = value.split('.'),
      _value$split2 = (0, _slicedToArray3.default)(_value$split, 2),
      number = _value$split2[0],
      decimals = _value$split2[1];

  if (value.includes('.')) {
    if (!decimals) return (0, _numeral2.default)(number).format('0,0') + '.';
    var newValue = number + '.' + decimals;
    if (decimals.length === 1) return (0, _numeral2.default)(newValue).format('0,0.0');
    var previousValue = ('' + previous).replace(/[^0-9.]/g, '');

    if (previousValue.includes('.')) {
      var prevdec = previousValue.split('.')[1];
      if (prevdec.length === 2) return previousValue;
    }

    return (0, _numeral2.default)(newValue).format('0,0.00');
  }

  return (0, _numeral2.default)(number).format('0,0');
};

var validate = function validate(value) {
  return /(?=.)^(([1-9][0-9]{0,2}(,[0-9]{3})*)|[0-9]+)?(\.[0-9]{1,2})?$/.test(value);
};

exports.default = (0, _type2.default)({
  type: 'string',
  format: format,
  validate: validate
});